export default "/dist/files/rubrique_telechargements.c69c14a49dc1a81fa03457a9925cabf1.svg";